export const orientations = ['', 'Portrait', 'Landscape'];

export const pageSizes = { portrait: 'A4', landscape: [720, 1280] };
